import { connect } from 'react-redux';
import { breadCrumbsSet } from '../../actions/global';
import { withTranslation } from '../../../i18n';
import { getDeliveryStart } from '../../actions/delivery';
import Delivery from './delivery';

const mapStateToProps = state => state;
const mapDispatchToProps = { breadCrumbsSet, getDeliveryStart };

export default withTranslation(['delivery'])(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(Delivery),
);
